import { render, staticRenderFns } from "./new-index.vue?vue&type=template&id=305c9f7e&scoped=true&"
import script from "./new-index.vue?vue&type=script&lang=js&"
export * from "./new-index.vue?vue&type=script&lang=js&"
import style0 from "./new-index.vue?vue&type=style&index=0&id=305c9f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c9f7e",
  null
  
)

export default component.exports